<script>import Modal from "@/core/components/Modal"
import PdfCertificate from "@/domains/lines/views/regularLines/components/PdfCertificate.vue"

export default {
  components: {
    Modal,
    PdfCertificate,
  },
  props: {
    idLinha: { type: String, default: null },
  },
  data: () => ({
    certificate: null,
    windowWidth: window.innerWidth,
    loading: false,
  }),
  watch: {
    closed() {
      this.page = 1
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize)
    })

    if (this.idLinha) {
      this.generateCertificate()
    }
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize)
  },

  methods: {
    async generateCertificate() {
      this.loading = true
      try {
        this.$Progress.start()
        const response = await this.$axios.get(
          "/api/certificado-linha/" + this.idLinha + "/true",
          {
            dataType: "binary",
            processData: false,
            responseType: "arraybuffer",
          }
        )
        let blob = new Blob([response["data"]], {
          type: response.headers["content-type"],
        })
        this.certificate = {
          url: window.URL.createObjectURL(blob),
        }
        this.$Progress.finish()
      } catch (e) {
        this.$Progress.finish()
        this.certificate = null
        this.$emit("close")
        this.$toast.error({
          title: "",
          message:
            "Não foi possível gerar o certificado porque o cadastro da linha está incompleto.",
        })
      } finally {
        this.loading = false
      }
    },
    onResize() {
      this.windowWidth = window.innerWidth
    },
  },
}
</script>

<template>
  <div>
    <div
      v-if="loading"
      class="fixed inset-0 z-50 flex items-start justify-center pt-24 bg-transparent cursor-wait"
    >
      <div class="bg-white rounded-lg px-6 py-4 shadow-lg text-center border">
        <div class="mb-2 font-semibold text-gray-800">
          Gerando certificado
        </div>
        <div class="text-sm text-gray-600">
          Aguarde...
        </div>
      </div>
    </div>

    <div v-if="certificate != null">
      <Modal
        :width="windowWidth > 1200 ? '1300' : '800'"
        :no-padding="true"
        :no-margin="true"
      >
        <div slot="body">
          <pdf-certificate :certificate="certificate" @close="$emit('close')" />
        </div>
        <div slot="footer"></div>
      </Modal>
    </div>
  </div>
</template>